export const ERROR_STATE = 'cw-app-error-state';
export const ERROR_STATE_TEXT = 'cw-app-error-state-text';
export const ERROR_STATE_CTA = 'cw-app-error-state-cta';
